import React from "react";
import {
	SEGMENT_CMC,
	URL_CMC_OPERATOR_AIRPORT_DATA,
	URL_CMC_OPERATOR_CAPACITY_DATA,
	URL_CMC_OPERATOR_CONTACTS_DATA,
	URL_CMC_OPERATOR_SCHEDULE_DATA,
	URL_DATA_FEEDS,
} from "../constants";
import { Hero } from "../sections/hero/Hero";
import { ProudToServe } from "../sections/proud-to-serve/ProudToServe";
import { Technology } from "../sections/Technology";
import { Testimonials } from "../../common/layout/testimonials/Testimonials";
import { ProductTabs } from "../sections/ProductTabs";
import { ProductSlider } from "../sections/ProductSlider";
import { Trial } from "../sections/Trial";
import { Upgrades } from "../sections/Upgrades";
import { Pricing } from "../sections/pricing/Pricing";
import { Faq } from "../sections/faq/Faq";
import { productPageProps } from "../../common/types/product";

export default function OperatorItData({
	packageName,
	subscribeLink,
	testimonials,
}: productPageProps) {
	return (
		<>
			<Hero
				title={packageName}
				subtitle="Get insight into Passenger Service System (PSS) providers for all scheduled operators as well as each PSS's customer list."
				packages={[
					{
						label: SEGMENT_CMC,
						features: [
							"Get info on the Reservation System Provider for each scheduled operator",
							"Get the directory of Reservation System Providers and Operator customers",
						],
						subscribeLinkUrl: subscribeLink,
					},
				]}
			/>
			<ProudToServe />
			<ProductTabs
				title={packageName}
				tabs={[
					{
						title: "Operator IT Provider",
						description:
							"Get access to a comprehensive overview of the IT Providers, including:",
						list: [
							"Name and legal name",
							"Status (active/inactive)",
							"Info (year founded)",
							"Website",
							"Location",
							"Product name",
							"Number of customers",
						],
						visual: {
							url: "/static/img/product/commercial-operator-it-data/it-provider-profile-overview.jpg",
						},
					},
					{
						title: "Operator IT System",
						description:
							"Get an overview of each reservation system, including:",
						list: [
							"System name and type",
							"Technology provider (e.g., Hitit Computer Services)",
							"Operator customers, with details such as operator name, IATA and ICAO codes, location (airport or headquarters), region, country, operator type (e.g., scheduled, charter, cargo), and operator status (active, inactive, merged, etc.)",
						],
						visual: {
							url: "/static/img/product/commercial-operator-it-data/operator-it-system-profile-overview.jpg",
						},
					},
				]}
			/>
			<ProductSlider
				description="Search for operators based on the reservation system they use."
				slides={[
					{
						title: "Operator Search",
						description:
							"Use an operator search to get a comprehensive list of all operators using a specific IT system.",
						visual: {
							url: "/static/img/product/commercial-operator-it-data/operator-search-by-reservation-system.jpg",
							title: "List of all operators using Sabre",
						},
					},
				]}
			/>
			<Upgrades
				packageName={packageName}
				modules={[
					{
						title: "Operator & Airport Data",
						content:
							"Get access to more than 14,000 commercial operator and airport profiles, as well as start-up operators worldwide.",
						url: URL_CMC_OPERATOR_AIRPORT_DATA,
					},
					{
						title: "Operator Schedule Data",
						content:
							"Get access to schedules of the vast majority of scheduled airlines worldwide.",
						url: URL_CMC_OPERATOR_SCHEDULE_DATA,
					},
					{
						title: "Operator Contacts Data",
						content:
							"Get a detailed contacts overview for almost any active as well as start-up operators worldwide.",
						url: URL_CMC_OPERATOR_CONTACTS_DATA,
					},
					{
						title: "Operator Capacity Data",
						content:
							"Get access to detailed capacity, frequency, and market share information for operators and airports worldwide .",
						url: URL_CMC_OPERATOR_CAPACITY_DATA,
					},
				]}
			>
				<Trial subscribeLink={subscribeLink} />
			</Upgrades>
			<Testimonials testimonials={testimonials} />
			<Technology exportOptionsAvailable={false} />
			<Pricing
				packageName={packageName}
				description="Gain a comprehensive understanding of the aviation industry with detailed, up-to-date insights."
				list={[
					"Get info on the PSS used by each scheduled operator",
					"Access a full directory of system providers and their operator clients",
				]}
				subscribeLink={subscribeLink}
				downloadsDescription="Commercial Aviation Operator IT Data is not available for download."
				downloadsAvailable={false}
			>
				<Trial subscribeLink={subscribeLink} />
			</Pricing>
			<Faq
				items={[
					{
						title: "Can I download this data set?",
						content:
							"The Commercial Aviation Operator IT Data cannot be downloaded.",
					},
					{
						title: "Can I integrate this data as a data feed into my own system?",
						content: (
							<p>
								Yes, Operator IT Data can be purchased as a data
								feed for seamless integration into your own
								system. ch-aviation also provides full support
								for the integration process. To learn more about
								data feeds, click{" "}
								<a
									href={URL_DATA_FEEDS}
									target="_blank"
									rel="noopener noreferrer"
								>
									here
								</a>
								.
							</p>
						),
					},
				]}
			/>
		</>
	);
}
